import * as React from "react";
const SvgIcPin = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 10V4h.75V2.5h-7.5V4H7v6l-2.5 1.5V13h4.9v4.5h1.2V13h4.9v-1.5L13 10Zm-6.4 1.5 1.9-.9V4h3v6.6l1.9.9H6.6Z" /></svg>;
export default SvgIcPin;